import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminMenu from '../AdminMenu';
import AdminHeader from '../AdminHeader';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { ADMIN_API_BASE } from "../../../utils/apiConfig";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBook, faInfo, faPencil} from "@fortawesome/free-solid-svg-icons";

const CoursesList = () => {
    const [courses, setCourses] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;

    const getCsrfToken = async () => {
        try {
            const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
                method: 'GET',
                credentials: 'include',
            });
            const data = await response.json();
            return data.csrfToken;
        } catch (error) {
            console.error('Error fetching CSRF token:', error);
            return null;
        }
    };

    useEffect(() => {
        const fetchCourses = async () => {
            const token = await getCsrfToken();
            try {
                const response = await axios.get(`${ADMIN_API_BASE}/course`, {
                    withCredentials: true,
                    headers: { 'csrf-token': token },
                });
                setCourses(response.data.data);
            } catch (error) {
                console.error('Error fetching courses:', error);
            }
        };

        fetchCourses();
    }, []);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const offset = currentPage * itemsPerPage;
    const currentCourses = (courses || []).slice(offset, offset + itemsPerPage);
    return (
        <>
            <div className="flex flex-1">
                <div className="w-1/5">
                    <AdminMenu path="./" />
                </div>
                <div className="flex-grow w-4/5">
                    <AdminHeader title="دوره‌ها" />
                    <div className="w-full flex flex-col justify-between gap-10 py-3 px-10 my-10">
                        {currentCourses.map((course) => (
                            <div
                                key={course.id}
                                className="bg-white shadow-md p-5 rounded-md w-full hover:bg-gray-100 hover:-translate-y-1 transition-all"
                            >
                                <h2 className="text-xl font-semibold mb-5">{course.id}</h2>
                                <div className="flex gap-3 w-full items-center">
                                    <Link
                                        to={`/admin/course/${course.id}/overview/`}
                                        className="bg-green-500 text-white px-5 py-3 flex items-center gap-2 rounded-md text-md"
                                    >
                                        <span>ویرایش اطلاعات جزئی</span>
                                        <FontAwesomeIcon icon={faPencil} size={"lg"} />
                                    </Link>
                                    <Link
                                        to={`/admin/course/${course.id}/details/`}
                                        className="bg-green-500 text-white px-5 py-3 flex items-center gap-2 rounded-md text-md"
                                    >
                                        <span>ویرایش اطلاعات بیشتر</span>
                                        <FontAwesomeIcon icon={faPencil} size={"lg"} />
                                    </Link>
                                    <Link
                                        to={`/admin/course/${course.id}/sections/`}
                                        className="bg-blue-500 text-white flex items-center px-5  py-3 gap-2 rounded-md text-md"
                                    >
                                        <span>ویرایش محتوا</span>
                                        <FontAwesomeIcon icon={faBook} size={"lg"} />
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                    <ReactPaginate
                        previousLabel={'قبلی'}
                        nextLabel={'بعدی'}
                        breakLabel={'...'}
                        pageCount={Math.ceil((courses || []).length / itemsPerPage)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination flex justify-center mt-4'}
                        activeClassName={'active'}
                        pageClassName={'page-item'}
                        pageLinkClassName={'page-link p-2 border rounded mx-1'}
                        previousClassName={'page-item'}
                        previousLinkClassName={'page-link p-2 border rounded mx-1'}
                        nextClassName={'page-item'}
                        nextLinkClassName={'page-link p-2 border rounded mx-1'}
                        breakClassName={'page-item'}
                        breakLinkClassName={'page-link p-2 border rounded mx-1'}
                    />
                </div>
            </div>
        </>
    );
};

export default CoursesList;
